<crowdctrl-tab-page
  [pageTitle]="pageTitle"
  [defaultHref]="defaultHref"
  [backButtonIcon]="backButtonIcon"
  [showRefresh]="showRefresh"
  [loadFn]="loadFn"
  [refreshFn]="refreshFn"
  [contentScrollY]="contentScrollY"
  [reloadDataOnEachViewActivation]="reloadDataOnEachViewActivation"
  [toolbarColor]="toolbarColor"
  [progressBarColor]="progressBarColor"
  contentClass="ion-padding-bottom crowdctrl-list-wrapper-content"
>
  <ng-content></ng-content>

  <ion-footer>
    <ion-toolbar class="crowdctrl-settings-list-tab-page__toolbar">
      <ion-buttons slot="primary" class="crowdctrl-settings-list-tab-page__buttons">
        <crowdctrl-loading-button
          type="button"
          expand="block"
          fill="solid"
          color="primary"
          [loading]="applyBusy"
          [disabled]="applyDisabled"
          (pressed)="onApplyClick()"
        >
          {{ applyLabel }}
        </crowdctrl-loading-button>
        <crowdctrl-loading-button
          type="button"
          expand="block"
          fill="outline"
          [loading]="cancelBusy"
          [disabled]="cancelDisabled"
          (pressed)="onCancelClick()"
        >
          {{ cancelLabel }}
        </crowdctrl-loading-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</crowdctrl-tab-page>
